import type { TRumAction, IddUseCases } from '@/utils/datadog/types';
import type { IRmTrackingActions } from './tracking.types';

export const ddActionRmTrackingActions = (
    { event, ...context }: IRmTrackingActions,
    use_case: IddUseCases
): TRumAction => {
    let description = 'RM IG event: ';

    if (event === 'entryUpdate') {
        description += 'User spin data changed';
    } else if (event === 'rm_game_spin') {
        description += 'User used a spin';
    } else if (event === 'rm_game_spin_won') {
        description += 'User had a lucky spin';
    } else if (event === 'rm_prize_claimed') {
        description += 'User complited a set of collectibles';
    } else if (event === 'rm_error') {
        description += 'User received an in-game error';
    } else if (event === 'modal_viewed') {
        description += 'User clicked info-button in game';
    } else if (event === 'cta_clicked') {
        description += 'User clicked cta';
    } else {
        description += 'Undefined event';
    }

    return {
        name: `RM_TRACKING_ACTIONS_${event}`,
        description,
        context,
        use_case
    };
};
